import { useState } from "react";
import { LifeBuoy, Send, Loader2, Check } from "lucide-react";
import { toast } from "sonner";
import { chatTicket } from "../../lib/api";
import { Button } from "../ui/button";
import { Input } from "../ui/input";

// Shown under an answer the assistant couldn't source: one tap opens a support ticket with the conversation attached.
export const TicketOffer = ({ lang = "en" }) => {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);
  const es = lang === "es";
  const send = async () => {
    if (!email.trim() || busy) return;
    setBusy(true);
    try {
      const r = await chatTicket(email.trim());
      setDone(r);
      toast.success(`${es ? "Ticket" : "Ticket"} ${r.number} ${es ? "abierto — te respondemos por email" : "opened — we'll reply by email"}`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || (es ? "No se pudo abrir el ticket" : "Couldn't open a ticket"));
    } finally {
      setBusy(false);
    }
  };
  if (done) return <div data-testid="chat-ticket-done" className="mt-2 inline-flex items-center gap-1 text-[11px] text-emerald-700"><Check className="h-3 w-3" /> {done.number} · <a href={done.link} className="underline" target="_blank" rel="noreferrer">{es ? "ver ticket" : "view ticket"}</a></div>;
  return (
    <div className="mt-2" data-testid="chat-ticket-offer">
      {!open ? (
        <button data-testid="chat-ticket-offer-btn" onClick={() => setOpen(true)} className="inline-flex items-center gap-1 rounded-full border border-border bg-card px-2.5 py-1 text-[11px] hover:border-primary hover:text-primary"><LifeBuoy className="h-3 w-3" /> {es ? "¿Prefieres preguntar a una persona?" : "Ask a human instead"}</button>
      ) : (
        <div className="flex items-center gap-1.5">
          <Input data-testid="chat-ticket-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()} placeholder={es ? "tu@email.com" : "you@email.com"} className="h-8 text-xs bg-card" />
          <Button data-testid="chat-ticket-send" size="sm" onClick={send} disabled={busy || !email.trim()} className="h-8 rounded-full px-3 text-[11px] gap-1">{busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <Send className="h-3 w-3" />} {es ? "Enviar" : "Send"}</Button>
        </div>
      )}
    </div>
  );
};
